import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({ title, description, keywords, ogImage, favicon, appleFavicon, canonical, noindex, jsonLd }) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="icon" href={favicon} />
            <link rel="apple-touch-icon" href={appleFavicon} />
            {canonical && <link rel="canonical" href={canonical} />}
            {noindex && <meta name="robots" content="noindex, follow" />}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="es_MX" />
            {canonical && <meta property="og:url" content={canonical} />}
            <meta property="og:site_name" content="Conferencia para Canadá" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
}

export default SEO;
